export default "__VITE_ASSET__BQKMyGkk__"